import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, InputAdornment, buttonClasses, useTheme } from '@mui/material';
import { Calendar2, CloseCircle } from 'iconsax-react';
import { HFilledTextField } from '../TextField';
import { useResponsive } from '@ui/style/useResponsive';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    weekStart: 1
});
const HSingleDatePicker = ({ handleSelectedDate, label = '', bg = 'light', value, readOnly = false, minDate, maxDate, clearable = false }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();
    // Convert incoming string value to Dayjs for MUI
    const getDateValue = () => {
        if (value && value !== '') {
            return dayjs(value);
        }
        return null;
    };
    // const handleDateValue = (selectedDate: Dayjs | null) => {
    //   if (selectedDate) {
    //     handleSelectedDate(selectedDate.toISOString());
    //   } else {
    //     handleSelectedDate(null);
    //   }
    // };
    const handleDateValue = (selectedDate) => {
        if (selectedDate) {
            handleSelectedDate(selectedDate.format('YYYY-MM-DD'));
        }
        else {
            handleSelectedDate(null);
        }
    };
    const handleClear = (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleSelectedDate(null);
    };
    return (_jsx(DatePicker, { value: getDateValue(), onChange: handleDateValue, desktopModeMediaQuery: '@media(min-width:9999px)', format: 'DD / MM / YYYY', minDate: minDate ? dayjs(minDate) : undefined, maxDate: maxDate ? dayjs(maxDate) : undefined, readOnly: readOnly, slotProps: {
            layout: {
                sx: {
                    '& .MuiPickersLayout-actionBar': {
                        [`& .${buttonClasses.root}:first-of-type`]: {
                            border: `1px solid ${theme.palette.primary.darker}`,
                            color: theme.palette.primary.darker,
                            backgroundColor: 'transparent',
                            '&:hover': {
                                border: `1px solid ${theme.palette.primary.darker}`,
                                color: theme.palette.primary.darker,
                                backgroundColor: 'transparent'
                            }
                        },
                        [`& .${buttonClasses.root}:last-of-type`]: {
                            backgroundColor: theme.palette.primary.darker,
                            color: theme.palette.mode === 'light'
                                ? theme.palette.common.white
                                : theme.palette.grey[800],
                            '&:hover': {
                                backgroundColor: theme.palette.primary.darker
                            }
                        }
                    }
                }
            }
        }, slots: {
            textField: (params) => (_jsx(HFilledTextField, { ...params, label: label, bg: bg, size: 'medium', sx: { cursor: 'pointer' }, fullWidth: true, placeholder: 'Select date', InputProps: {
                    ...params.InputProps,
                    readOnly: readOnly,
                    endAdornment: (_jsxs(InputAdornment, { position: 'end', sx: { gap: 0.5 }, children: [clearable && value && !readOnly && (_jsx(IconButton, { size: 'small', edge: 'end', "aria-label": 'Clear date', onClick: handleClear, sx: { p: 0.25 }, children: _jsx(CloseCircle, { size: 18, color: bg === 'blue' ? theme.palette.action.active : theme.palette.text.secondary }) })), _jsx(Calendar2, { className: 'end', fontSize: 20, style: { marginRight: 5 }, color: bg === 'blue' ? theme.palette.action.active : theme.palette.text.primary })] }))
                } }))
        } }));
};
export default HSingleDatePicker;
